module.exports.LegacyPowerUps = {
  calendar: '55a5d917446f517774210011',
  cardAging: '55a5d917446f517774210012',
  voting: '55a5d917446f517774210013',
};
